var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",class:{
	'fixed-top': _vm.fixed && _vm.fixed_position == 'top',
	'fixed-bottom': _vm.fixed && _vm.fixed_position == 'bottom'
},style:(_vm.space_fixed)},[_c('b-row',{staticClass:"justify-content-center",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12","sm":"8","md":"6","lg":"4","xl":"4"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2004d8e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/WrapperMobileView.vue
// module id = null
// module chunks = 